module.exports = __webpack_public_path__ + "media/SoloAcousticGuitar.31ce2f2c.mp3";